import React,{Fragment} from "react";
import { Route } from "react-router-dom";

function _blankRoute({ component: Component, ...rest }) {
  return (
    <Route
      {...rest}
      render={(props) => {
        return (
          <Fragment {...props}>
            <Component {...props} />
          </Fragment>
        );
      }}
    />
  );
}

export default _blankRoute;
